export const getDataToStore = (data, businessOwnerId) => {
  const photoObj = data.coverPhoto.file ? { photo: data.coverPhoto.file } : {};
  const idObj = data.id ? { id: parseInt(data.id) } : {};
  const businessOwnerIdObj = businessOwnerId
    ? { businessOwnerId: businessOwnerId }
    : {};
  return {
    ...photoObj,
    widgetSettings: {
      ...idObj,
      color: data.color,
      languages: data.languages,
      privacyPolicy: data.privacyPolicy,
      termsAndConditions: data.termsAndConditions,
      ...businessOwnerIdObj
    }
  };
};
